import Vue from "vue"
import Vuex from "vuex"
import createLogger from "vuex/dist/logger"

import AdBanner from "./modules/ad-banner/ad-banner.module"
import Auth from "./auth/auth.module"
import Coaching from "./coaching/coaching.module"
import Courses from "./modules/courses"
import Estimator from "./modules/estimator"
import Fortnite from "./modules/fortnite"
import Games from "./modules/games"
import Guides from "./modules/guides"
import Instapro from "./modules/instapro"
import Job from "./modules/job"
import LeagueOfLegends from "./modules/leagueoflegends"
import LiveClasses from "./modules/live_classes"
import Maps from "./modules/maps"
import Message from "./modules/message"
import Modals from "./modules/modals"
import Onboarding from "./modules/onboarding"
import PaymentLegacy from "./modules/payment/payment.modules"
import SSBU from "./modules/ssbu"
import Settings from "./modules/settings"
import Start from "./modules/start"
import Store from "./modules/store"
import Subscriptions from "./modules/subscriptions"
import Task from "./modules/task"
import TeamfightTactics from "./modules/teamfight_tactics"
import Tracking from "./modules/tracking"
import Trending from "./modules/trending"
import VideoOfTheDay from "./modules/video_of_the_day"
import Weapons from "./modules/weapons"
// new modules
import Aimlabs from "./aimlabs/aimlabs.module"
import Bootcamp from "./bootcamp/bootcamp.module"
import BootcampEnroll from "./bootcamp-enroll/bootcamp-enroll.module"
import Coach from "./coach/coach.module"
import Game from "./game/game.module"
import Home from "./home/home.module"
import Notification from "./notification/notification.module"
import Optimizely from "./optimizely/optimizely.module"
import Oauth from "./oauth/oauth.module"
import Payment from "./payment/payment.module"
import Pusher from "./pusher/pusher.module"
import User from "./user/user.module"
import Util from "./utils/util.module"
import Vod from "./vod/vod.module"

Vue.use(Vuex)

const plugins = process.env.NODE_ENV !== "production" && process.env.LOGGER
  ? [ createLogger() ]
  : [];

const createStore = new Vuex.Store({
  plugins,
  modules: {
    AdBanner,
    Aimlabs,
    Auth,
    Bootcamp,
    BootcampEnroll,
    Coach,
    Coaching,
    Courses,
    Estimator,
    Fortnite,
    Game,
    Games,
    Guides,
    Home,
    Instapro,
    Job,
    LeagueOfLegends,
    LiveClasses,
    Maps,
    Message,
    Modals,
    Notification,
    Oauth,
    Onboarding,
    Optimizely,
    Payment,
    PaymentLegacy,
    Pusher,
    SSBU,
    Settings,
    Start,
    Store,
    Subscriptions,
    Task,
    TeamfightTactics,
    Tracking,
    Trending,
    User,
    Util,
    VideoOfTheDay,
    Vod,
    Weapons,
  },
  strict: false,
})

export default createStore



// WEBPACK FOOTER //
// ./src/store/index.store.js